export default [
    {
      no: 1,
      roleName: "ผู้ดูแลระบบ", 
      detail:"จัดการได้ทุกอย่าง",      
      status:"available"     
    },      
  
  ]